/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Planner_SummaryInputs */

const en_control_planner_summary = /** @type {(inputs: Control_Planner_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your build summary`)
};

const zh_control_planner_summary = /** @type {(inputs: Control_Planner_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前配置`)
};

/**
* | output |
* | --- |
* | "Your build summary" |
*
* @param {Control_Planner_SummaryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_planner_summary = /** @type {((inputs?: Control_Planner_SummaryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Planner_SummaryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_planner_summary(inputs)
	return zh_control_planner_summary(inputs)
});
export { control_planner_summary as "control.planner.summary" }